<div class="card" [ngClass]="styleClass">
    <div class="card__header" [ngClass]="{ 'header--empty': isEmptyHeader }">
        <ng-container [ngTemplateOutlet]="cardHeaderTemplate || defaultCardHeader"></ng-container>

        <ng-template #defaultCardHeader>
            <div class="row">
                <div class="header__title col-6">
                    <h2>{{ title }}</h2>
                </div>

                <div class="header__cta col-6">
                    <cap-button *ngIf="buttonLabel"
                               styleClass="default round"
                               (click)="buttonClick?.emit()"
                               [label]="buttonLabel"
                               [icon]="buttonIcon"
                               iconPos="left"></cap-button>

                    <i *ngIf="settings" class="fas fa-ellipsis-v settings" (click)="settingClick.emit()"></i>
                </div>
            </div>
        </ng-template>
    </div>

    <div class="card__content" [ngClass]="{ 'content--gutter': !isEmptyHeader }">
        <ng-container [ngTemplateOutlet]="cardContentTemplate"></ng-container>
    </div>
</div>
